<template>
  <div>
    <MenuCount_Storage/>
    <Warehouse_Create/>
  </div>
</template>

<script>
import Warehouse_Create from "@/components/admin/stock/count_storage/Warehouse_create";
import MenuCount_Storage from "@/components/admin/stock/count_storage/menucount_storage/MenuCount_Storage";
export default {
  name: "WarehouseCreate",
  components: {
    MenuCount_Storage,
    Warehouse_Create,
  }
}
</script>

<style scoped>

</style>
